import { Injectable } from '@angular/core';

declare global {
  interface Window { Featurebase: any; }
}

@Injectable({ providedIn: 'root' })
export class FeaturebaseService {
  initialize(email: string) {
    if (window.Featurebase) {
      window.Featurebase('initialize_feedback_widget', {
        organization: 'plugya',
        theme: 'light',
        placement: 'right',
        email,
        locale: 'en',
        metadata: null
      });
    }
  }
} 